export default "__VITE_ASSET__BuSSkfnS__"